/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card/LocationName/Content"
  
}) {
let reusableMethodProviderLocationAccountLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'reusable_method',
path: 'provider_location_account.location.name',
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 style="grey"
 type="outline"
 marginTop={1}
 alignSelf="unset"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="reusable_method.provider_location_account.location.name"
 text={reusableMethodProviderLocationAccountLocationNameValueData}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}